import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ProjectIcon from '@core/components/project-icon/ProjectIcon.vue'
Vue.component(FeatherIcon.name, FeatherIcon,ProjectIcon);
// Vue.component('ProjectIcon', ProjectIcon);
